export const MAX_COMMUNITIES_TO_DISPLAY = 5;

/** Clears sidebar loading state after in-app community switch navigation. */
export const NAVIGATION_TIMEOUT_MS = 1000;

/** Community-to-community navigation only; excludes Discover, New Community, and other chrome. */
export const COMMUNITY_SWITCHER_NAV_SELECTOR = "[data-community-switcher-nav]";

/** Highest 1-based position that can be bound to the `Alt+G+N` keyboard shortcut. */
export const MAX_HOTKEY_POSITION = 8;
